import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useErrorHandler} from 'react-error-boundary'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../../consts'
import {createDemandOverride, salesForecastQueryKeys} from '../backend'

type CreateDemandOverrideParams = Parameters<typeof createDemandOverride>[0]

export const useCreateDemandOverride = () => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const raiseError = useErrorHandler()
  const queryClient = useQueryClient()

  return useMutation<void, AxiosError, CreateDemandOverrideParams>({
    mutationFn: createDemandOverride,
    mutationKey: ['createDemandOverride'],
    onError: (error) => {
      const message = (error.response?.data as {message?: string})?.message
      if (message) {
        spawnErrorToast(message)
      } else {
        raiseError(error)
      }
    },
    onSuccess: () => {
      spawnSuccessToast(t('success.createSalesForecastOverride'))
    },
    onSettled: () => {
      void queryClient.invalidateQueries({
        queryKey: [salesForecastQueryKeys.materialDemand]
      })
      void queryClient.invalidateQueries({
        queryKey: ['stockDevelopment']
      })
    }
  })
}
